import { type FC } from "react";
import { type SurveyFiltersEnum } from "../../../features/Library/Surveys/types/models";
import { type FilterFormPropsBase } from "../types/props";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { getSurveyFilters } from "./surveyFilters";

export interface SurveyFilterFormForPacksProps extends FilterFormPropsBase<SurveyFiltersEnum> {}

const SurveyFilterFormForPacks: FC<SurveyFilterFormForPacksProps> = ({
  filterOptions,
  filter,
  updateFilter,
  onValidationChange,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getSurveyFilters(false)}
    onValidationChange={onValidationChange}
  />
);

export default SurveyFilterFormForPacks;
